module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-menu",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dialog-ctx"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("交警业务")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.batrcl()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-beiancheliangSVG"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("备案他人车辆")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("绑定他人车辆，查询处理交通违法")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cjgyw()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-chejiaguanyewu"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("车驾管业务")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("驾驶证、行驶证及车牌业务办理")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74dbe6c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/traffic_dialog/traffic_dialog.vue
// module id = 325
// module chunks = 40